// Collections list route

import { createFileRoute } from '@tanstack/react-router';

import { CollectionsPage } from '@/features/datahub/collections/CollectionsPage';
import { DataHubLayout } from '@/features/datahub/components/DataHubLayout';

function CollectionsRoute() {
  return (
    <DataHubLayout activeTab="collections">
      <CollectionsPage />
    </DataHubLayout>
  );
}

export const Route = createFileRoute('/_authenticated/datahub/collections/')({
  component: CollectionsRoute,
});
